module.exports = __webpack_public_path__ + "static/media/rpa.81a8bfb7.svg";